export const postMessageContentHeight = (height) => {
	// eslint-disable-next-line
  if(parent.postMessage) {
    // eslint-disable-next-line
    parent.postMessage(height, "*");
  }
}
